import React, {useMemo} from 'react';

import {useUnit} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {userModel} from '@/entities/user/model';
import {Wrapper} from '@pages/EployersControl/Header/styled';
import {Title} from '@shared/ui/Title';

export const Header = () => {
    const {t} = useTranslation();
    const user = useUnit(userModel);

    const title = useMemo(() => {
        if (user.isDirector) return t('page_employers_control.title.employees');
        if (user.isChiefInspector) return t('page_employers_control.title.inspectors');
        if (user.isOperator) return t('page_employers_control.title.users');
        return t('page_employers_control.title.employees');
    }, [user, t]);

    return (
        <Wrapper>
            <Title size={2}>{title}</Title>
        </Wrapper>
    );
};
